import { appointmentRouter } from './router'

export { appointmentRouter }
